import React from 'react';
import appClass from './App.APP_TARGET.scss';
import PropTypes from 'prop-types';
import SessionManger from './components/SessionManager/SessionManger';

const IsolatedView = ({ children }) => {
    return (<div id="container" className={ appClass.container }>
        {children}
        <SessionManger />
    </div>);
};

IsolatedView.propTypes = {
    children: PropTypes.node
};

export default IsolatedView;
